import type { CopilotConfigurationTemplate } from '@factoryfixinc/ats-interfaces';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCopilotConfigurationTemplate = defineStore(
  'copilotConfigurationTemplate',
  () => {
    const templates = ref<CopilotConfigurationTemplate[]>([]);
    const selectedTemplate = ref<CopilotConfigurationTemplate | null>(null);
    // null until fetched, so the default Copilot card can hide its footer instead of showing 0
    const defaultCopilotJobCount = ref<number | null>(null);

    return {
      defaultCopilotJobCount,
      selectedTemplate,
      templates,
    };
  },
  {
    // The store is persisted without an employer key; the job count is per employer and per
    // page load, so it is fetched fresh instead of restored.
    persist: { omit: ['defaultCopilotJobCount'] },
  },
);
